/**
 * 待合成
 */

<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>待合成</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
     <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.filename" placeholder="关键字"></el-input>
      </el-form-item>
      <el-select v-model="formInline.status" placeholder="请选择订单状态">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-form-item label="接收时间：">
        <el-date-picker
          v-model="formInline.date"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>

      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="success" icon="el-icon-setting" @click="createpdf()">开始合成</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" @selection-change="selectChange" :data="listData" highlight-current-row v-loading="loading"
              border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="80px">
      </el-table-column>
      <el-table-column align="center" prop="custom_ORDER_NO" label="SKUID">
        <div slot-scope="scope">
            <span v-if="Date.parse(scope.row.createtime)-20*60*60*1000 <new Date()" >
                 {{scope.row.skuid}}
               </span>
          <span v-else style="color:black;">
  				    	 {{scope.row.skuid}}
  				    </span>
        </div>


      </el-table-column>

      <el-table-column align="center" prop="custom_ORDER_NO" label="SN序列号">
        <div slot-scope="scope">
            <span v-if="Date.parse(scope.row.createtime)-20*60*60*1000 <new Date()" >
                 {{scope.row.sn}}
               </span>
          <span v-else style="color:black;">
  				    	 {{scope.row.sn}}
  				    </span>
        </div>
      </el-table-column>

      <el-table-column align="center" prop="custom_ORDER_NO" label="外部采购订单号">
        <div slot-scope="scope">
            <span v-if="Date.parse(scope.row.createtime)-20*60*60*1000 <new Date()" >
                 {{scope.row.in_STORE_BATCH_NO}}
               </span>
          <span v-else style="color:black;">
  				    	 {{scope.row.in_STORE_BATCH_NO}}
  				    </span>
        </div>
      </el-table-column>
      <el-table-column align="center" prop="custom_ORDER_NO" label="物料套装名称">
        <div slot-scope="scope">
            <span v-if="Date.parse(scope.row.createtime)-20*60*60*1000 <new Date()" >
                 {{scope.row.mati_SET_NAME}}
               </span>
          <span v-else style="color:black;">
  				    	 {{scope.row.mati_SET_NAME}}
  				    </span>
        </div>
      </el-table-column>

<!--      <el-table-column align="center" prop="filename" label="物流商">-->
<!--        <div slot-scope="scope">-->
<!--            <span v-if="Date.parse(scope.row.createtime)-20*60*60*1000 <new Date()" >-->
<!--                {{scope.row.logistics_CODE}}-->
<!--               </span>-->
<!--          <span v-else style="color:black;">-->
<!--  				    	{{scope.row.logistics_CODE}}-->
<!--  				    </span>-->
<!--        </div>-->
<!--      </el-table-column>-->
      <el-table-column align="center" prop="order_DATE" label="下单日期">

        <div slot-scope="scope">
            <span v-if="Date.parse(scope.row.createtime)-20*60*60*1000 <new Date()" >
                {{scope.row.order_DATE|timestampToTime}}
               </span>
          <span v-else style="color:black;">
  				    	{{scope.row.order_DATE|timestampToTime}}
  				    </span>
        </div>
      </el-table-column>

      <el-table-column align="center" prop="createtime" label="接收时间">
        <div slot-scope="scope">
            <span v-if="Date.parse(scope.row.createtime)-20*60*60*1000 <new Date()" >
                {{scope.row.createtime|timestampToTime}}
               </span>
          <span v-else style="color:black;">
  				    	{{scope.row.createtime|timestampToTime}}
  				    </span>
        </div>

      </el-table-column>

<!--      <el-table-column align="center" prop="status" label="距离最晚发货时间">-->

<!--        <orderStatus slot-scope="scope">-->
<!--            <span v-if="Date.parse(scope.row.createtime)-20*60*60*1000 <new Date()" >-->
<!--                	 {{scope.row.range}}-->
<!--               </span>-->
<!--          <span v-else style="color:black;">-->
<!--  				    		 {{scope.row.range}}-->
<!--  				    </span>-->
<!--        </orderStatus>-->

<!--      </el-table-column>-->
      <el-table-column align="center" prop="status" label="订单状态">

        <!--      <span v-if="new Date()-Date.parse(scope.row.updatetime)>60*60*1000" >
                   合成失败
                  </span>
             <span v-else>-->

                <orderStatus slot-scope="scope">
                   <span v-if="new Date()-Date.parse(scope.row.updatetime)>60*60*1000&&scope.row.status==-1" >
                   合成失败
                  </span>
               <span v-else="Date.parse(scope.row.createtime)-20*60*60*1000 <new Date()" >
                    {{scope.row.status|OrderStatus}}
                  </span>
             <span v-else style="color:black;">
                    {{scope.row.status|OrderStatus}}
                 </span>
           </orderStatus>
               <!--  </span>-->


        <!--<span v-if="scope.row.createtime>=new Date(new Date().getTime() - 24*60*60*1000)" style="color:red">已超时</span>-->
      </el-table-column>

      <!--      <el-table-column align="center" label="操作" min-width="150">-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>-->
      <!--          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :visible.sync="dialogVisible" @close="dislogClosed">

      <p>提示</p>
      <p>生成通知已发送到本地服务器,请到本地服务器查看PDF生成情况,切勿重复操作!!! </p>
      <span slot="footer" class="dialog-footer">
     <el-button @click="dialogVisible = false">关闭</el-button>
     </span>
    </el-dialog>

  </div>
</template>

<script>
  import {
    compose,
    waitComposeList,

  } from '../../api/ordersMG'
  import Pagination from '../../components/Pagination500'

  export default {
    name: "orders",
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        dialogVisible:false,
        formInline: {
          date: [],
          filename: "",
          status:"",
          pageNum: 1,
          pageSize: 500
        },
        date: '',
        selectdata: [],
        listData: [], //用户数据

        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 500,
          total: 500
        },
        options: [{
          value: '99',
          label: '全部'
        },{
          value: '-1',
          label: '合成失败/正在合成'
        }, {
          value: '0',
          label: '待合成'
        }],
        status: '99'
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 选择复选框事件
      selectChange(val) {
        this.selectdata = val
      },

      // 获取订单列表
      getdata(parameter) {
        this.loading = true


        /***
         * 调用接口，注释上面模拟数据 取消下面注释
         */
        waitComposeList(parameter)
          .then(res => {
            this.loading = false
            if (res.code != 0) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.data
              // 分页赋值
              this.pageparm.currentPage = this.formInline.pageNum
              this.pageparm.pageSize = this.formInline.pageSize
              this.pageparm.total = res.count
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('数据加载失败，请稍后再试！')
          })

      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.pageNum = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.getdata(this.formInline)
      }
      ,
      stautsFormat(row, column) {

      if (row.status === 0) {
        return '待合成'
      } else if (row.status === 1) {
        return '已合成'
      } else if (row.status === -1) {
        return '正在合成'
      }else if (row.status === 2) {
        return '已发货'
      }
    }
    , createpdf()
    {
        let len = this.selectdata
        if (len == 0) {
          this.$message({
            type: 'warning',
            message: "请选择需要待合成数据"
          })
          return
        }
        let params = {
          ids: ''
        }
        let idlist = []
        if (len != 0) {
          for (let i = 0; i < len.length; i++) {
            idlist.push(len[i].id)
          }
        }

        params.ids = idlist.join(',')

        this.loading = true
        compose(params)
          .then(res => {
            this.loading = false
            if (res.code != 0) {
              this.$message({
                type: 'error',
                message: res.msg
              })
            } else {
              this.search();
              this.dialogVisible=true;
              // this.$message({
              //   type: 'info',
              //   message: "生成通知已发送到本地服务器,请注意查看pdf生成情况。 pdf正在生成时，请不要再做其他生成操作，切记！！！"
              // })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('未知错误！')
          })
      }

    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/views/orders/WaitCompose.vue